import { Injectable } from "@angular/core";
import { Actions, concatLatestFrom, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { AppError, MessageScopeType, MessageService, MessageType } from "@obg/ngx.core";
import { DeviceConfigService } from "@obg/ngx.global";
import { merge, of } from "rxjs";
import { catchError, map, mergeMap } from "rxjs/operators";

import { CoreContentState } from "../state";

import { MenuAction } from "./menu.action";
import { menuMessageContext } from "./menu.const";
import { MenuSelector } from "./menu.selector";
import { MenuService } from "./menu.service";

/**
 * @deprecated [fabric-deprecated]
 */
@Injectable()
export class MenuEffect {
	fetchMenu$ = createEffect(() =>
		this.actions$.pipe(
			ofType(MenuAction.fetchAllByName),
			// switchMap => mergeMap for edge cases where sometimes several requests are shot at once
			mergeMap(({ payload }) =>
				this.service.getAllByName(payload, this.deviceConfigService.getType()).pipe(
					map((menus) => MenuAction.fetchSuccess(payload, menus)),
					catchError((error: AppError) => of(MenuAction.fetchFail(error)))
				)
			)
		)
	);

	/**
	 * @deprecated [fabric-deprecated] - Use fabric ContentService from svc-content instead
	 */
	getMenu$ = createEffect(() =>
		this.actions$.pipe(
			ofType(MenuAction.getAllByName),
			concatLatestFrom(() => this.store.select(MenuSelector.getKeysLoaded)),
			map(([{ payload }, keysLoaded]) => payload.filter((menuName) => !keysLoaded.includes(menuName))),
			map((names) => MenuAction.fetchAllByName(names))
		)
	);

	/**
	 * @deprecated [fabric-deprecated] - Use fabric ContentService from svc-content instead
	 */
	initMessages$ = createEffect(
		() =>
			merge(
				this.messageService.mapErrorByContext$(
					{
						[MenuAction.fetchFail.type]: menuMessageContext.fetch,
					},
					MessageScopeType.Global,
					MessageType.Error
				),
				this.messageService.mapClearByContext$({
					[MenuAction.fetchAllByName.type]: menuMessageContext.fetch,
				})
			),
		{ dispatch: false }
	);

	constructor(
		private actions$: Actions,
		private service: MenuService,
		private store: Store<CoreContentState>,
		private messageService: MessageService,
		private deviceConfigService: DeviceConfigService
	) {}
}
